
const digest = '4f457947f81fe9cbd4847c2997513160a8e7581d0855f5aa2a22437f99d7f272';
const classes = {"item":"_item_1y3lj_1","header":"_header_1y3lj_9","title":"_title_1y3lj_15","consents":"_consents_1y3lj_23","consent":"_consent_1y3lj_23"};
const css = `._item_1y3lj_1 {
  font-family: Rubik, sans-serif;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
._item_1y3lj_1 ._header_1y3lj_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px;
}
._item_1y3lj_1 ._header_1y3lj_9 ._title_1y3lj_15 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
}
._item_1y3lj_1 ._consents_1y3lj_23 {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #d1d4da;
  padding: 24px;
}
._item_1y3lj_1 ._consents_1y3lj_23 ._consent_1y3lj_23 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}
._item_1y3lj_1 ._consents_1y3lj_23 ._consent_1y3lj_23 a {
  color: #1665d8;
  text-decoration: underline;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  